// The contract with the backend's TenantHub (ADR-0034, ADR-0051): one hub per tenant, and
// the exact message and method names on both sides. Every name used with the live channel
// comes from here, like API paths come from api-paths.js.

export const REALTIME_HUB_PATH = "/hubs/tenant";

// Server → browser
export const REALTIME_EVENTS = Object.freeze({
  BANNER_CHANGED: "BannerChanged",
  NOTIFICATIONS_CHANGED: "NotificationsChanged",
  PAGE_LOCKED: "PageLocked",
  PAGE_UNLOCKED: "PageUnlocked",
});

// Browser → server
export const REALTIME_METHODS = Object.freeze({
  JOIN_PAGE: "JoinPage",
  GET_LOCK_STATUS: "GetLockStatus",
  START_EDITING: "StartEditing",
  RENEW_EDITING: "RenewEditing",
  STOP_EDITING: "StopEditing",
});
